import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from "@angular/router";
import {NavigationService} from "../navigation/navigation.service";
import {Observable} from "rxjs";
import {ContentsHelper} from "../../helpers/contents.helper";
import {ListingService} from "./listing.service";
import {HelperService} from '../helperService';


@Injectable()
export class ListingContentsResolver implements Resolve<any>
{


    /**
     * Function > contentsService
     * @param OBJ_navigation_service
     * @param OBJ_listing_service
     * @param OBJ_helper_service
     */
	constructor
	(
		private OBJ_navigation_service: NavigationService,
		private OBJ_listing_service: ListingService,
		private OBJ_helper_service: HelperService
	) {} // end function contentsService


	/**
	 * Function > resolve
	 * @desc Gibt den ContentHelper zurueck, mit Hilfe dessen man durch Json navigieren kann
	 * @param {object} OBJ_route
	 * @param {object} OBJ_state
	 * @returns {Observable<ContentsHelper>}
	 */
	resolve(OBJ_route: ActivatedRouteSnapshot, OBJ_state: RouterStateSnapshot): Observable<ContentsHelper>
	{

        let STR_route_submenu = OBJ_route.paramMap.get("route_submenu");

        let STR_route_menu = OBJ_route.parent.paramMap.get("route_menu");

		let STR_route_listing_id = OBJ_route.paramMap.get("listing_id");

        let OBJ_table_data = this.OBJ_helper_service.getFromLocalstorage("table" + "/" + STR_route_menu + "/" + STR_route_submenu + (STR_route_listing_id?("/" + STR_route_listing_id):""));

        this.OBJ_helper_service.logWithClassAndFunction("ListingContentsResolver", "resolve", {"Table_data": OBJ_table_data});

		let OBJ_config = this.OBJ_navigation_service.getMenuitemConfigByRoute(STR_route_menu, STR_route_submenu, STR_route_listing_id);

        // Sortierung etc. im Localstorage gespeichert
        if(OBJ_table_data)
		{
			// Soll State wiederhergestellt werden
			if(OBJ_route.queryParams["keepState"])
			{
                return this.OBJ_listing_service.getHelper(STR_route_menu, STR_route_submenu, STR_route_listing_id, OBJ_table_data.length, OBJ_table_data.start,
					OBJ_table_data.sort_by, OBJ_table_data.order_dir, OBJ_table_data.search.search, OBJ_table_data.searchfields);

            }
            else
			{
				// ansonsten raeume localstorage auf
                this.OBJ_helper_service.removeFromStorage("table" + "/" + STR_route_menu + "/" + STR_route_submenu + (STR_route_listing_id?("/" + STR_route_listing_id):""));
			} // end if

		} // end if

		// Initial sorting is given
		if(OBJ_config._links.values.sort)
		{
			return this.OBJ_listing_service.getHelper(
				STR_route_menu,
				STR_route_submenu,
				STR_route_listing_id,
				25,
				0,
				OBJ_config._links.values.sort.sort_by,
				OBJ_config._links.values.sort.order,
				);
		} // end if

        return this.OBJ_listing_service.getHelper(STR_route_menu, STR_route_submenu, STR_route_listing_id);

	} // end function resolve


} // end class ListingContentsResolver
